import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon, PhoneIcon, MenuIcon, XIcon, ArrowUpRightIcon } from "lucide-react";
import { PillButton } from "./PillButton";
const links = [{
  label: "Home",
  href: "#",
  active: true
}, {
  label: "About",
  href: "#about"
}, {
  label: "Expertise",
  href: "#expertise",
  menu: true
}, {
  label: "Insights",
  href: "#insights"
}, {
  label: "Contact",
  href: "#contact"
}];
const ease = [0.23, 1, 0.32, 1] as const;
export function Navbar() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && setOpen(false);
    const onResize = () => window.innerWidth >= 1024 && setOpen(false);
    window.addEventListener("keydown", onKey);
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("resize", onResize);
    };
  }, [open]);
  return <header className="absolute inset-x-0 top-0 z-30 px-2 pt-2 sm:px-3 sm:pt-3" data-id="element-173" data-mp="9ny1y42putcy">
      <nav aria-label="Primary" className="w-full rounded-xl bg-white" data-id="element-174" data-mp="emj3q7xm9l3i">
        <div className="flex h-16 items-center justify-between pl-5 pr-2 sm:h-[76px] sm:pl-8 sm:pr-3" data-id="element-175" data-mp="jmx2t0h8pkpe">
          <a href="#" className="whitespace-nowrap text-[17px] font-bold tracking-[-0.03em] text-ink sm:text-[19px]" data-id="element-176" data-mp="om9zse1ts85p">
            Northgate Legal<span className="text-accent" data-id="element-177" data-mp="3n4owqkexseq8">.</span>
          </a>

          <ul className="hidden items-center gap-1 lg:flex" data-id="element-178" data-mp="3s1xisw37h2wr">
            {links.map(link => <li key={link.label} data-id="element-179" data-mp="vmdgnr5xfzm">
                <a href={link.href} aria-current={link.active ? "page" : undefined} className={`inline-flex h-9 items-center gap-1 rounded-full px-4 text-[14px] font-medium transition-colors duration-150 ${link.active ? "bg-ink text-white" : "text-ink/70 hover:bg-cream hover:text-ink"}`} data-id="element-180" data-mp="ul0ueui0lfs">
                  {link.label}
                  {link.menu && <ChevronDownIcon className="h-3.5 w-3.5" strokeWidth={2} aria-hidden="true" data-id="element-181" data-mp="2wc6ql0dyv1w4" />}
                </a>
              </li>)}
          </ul>

          <div className="flex items-center gap-2 sm:gap-5" data-id="element-182" data-mp="3b0b7pzxdf5cs">
            <a href="tel:+442000000000" className="hidden items-center gap-3 xl:flex" data-id="element-183" data-mp="361q8a2py0ppe">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent/10 text-accent" data-id="element-184" data-mp="2ibvwzpl9v979">
                <PhoneIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-185" data-mp="2dedw8mhes0ac" />
              </span>
              <span className="leading-tight" data-id="element-186" data-mp="2sbmu7z17w2b1">
                <span className="block text-[12px] text-stone" data-id="element-187" data-mp="2s88qamcwnl1h">Call now</span>
                <span className="block text-[14px] font-semibold text-ink" data-id="element-188" data-mp="2na761y3qtfof">+44 (0)20 0000 0000</span>
              </span>
            </a>
            <div className="hidden md:block" data-id="element-189" data-mp="2ljeqp18s8uc">
              <PillButton href="#contact" variant="dark" data-id="element-190" data-mp="2krjjfbk4d4l">
                Book a Consultation
              </PillButton>
            </div>
            <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? "Close menu" : "Open menu"} className="flex h-12 w-12 items-center justify-center rounded-full bg-cream text-ink transition-colors duration-150 hover:bg-line lg:hidden" data-id="element-191" data-mp="f3vjtc3u91ep">
              {open ? <XIcon className="h-5 w-5" strokeWidth={1.75} data-id="element-192" data-mp="xu3gpcgy2vmg" /> : <MenuIcon className="h-5 w-5" strokeWidth={1.75} data-id="element-193" data-mp="xtv5rq4du0dw" />}
            </button>
          </div>
        </div>

        <AnimatePresence initial={false} data-id="element-194" data-mp="k0vqnp8ii86v">
          {open && <motion.div id="mobile-menu" initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: "auto",
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.25,
          ease
        }} className="overflow-hidden lg:hidden" data-id="element-195" data-mp="o3idfbqbt2x7">
              <div className="border-t border-line px-5 pb-5 pt-2 sm:px-8" data-id="element-196" data-mp="3p38ixb3dwa3x">
                <ul data-id="element-197" data-mp="3k22n34efg6q6">
                  {links.map(link => <li key={link.label} className="border-b border-line last:border-b-0" data-id="element-198" data-mp="3f3hotaiqjx4d">
                      <a href={link.href} onClick={() => setOpen(false)} aria-current={link.active ? "page" : undefined} className="group flex items-center justify-between py-4 text-[22px] font-semibold tracking-[-0.03em] text-ink" data-id="element-199" data-mp="3b2fiyaubcmtf">
                        <span className="flex items-center gap-3" data-id="element-200" data-mp="1vob3azpy6uf">
                          {link.active && <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-accent" data-id="element-201" data-mp="3u08n1ggob2se" />}
                          {link.label}
                        </span>
                        <ArrowUpRightIcon className="h-5 w-5 text-stone transition-[transform,color] duration-150 group-hover:rotate-45 group-hover:text-accent" strokeWidth={1.75} aria-hidden="true" data-id="element-202" data-mp="pma723wg80o2" />
                      </a>
                    </li>)}
                </ul>
                <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between" data-id="element-203" data-mp="2m931o39a8qxz">
                  <a href="tel:+442000000000" className="flex items-center gap-3 rounded-lg bg-cream px-4 py-3" data-id="element-204" data-mp="2r8xq805l54fv">
                    <PhoneIcon className="h-4 w-4 text-accent" strokeWidth={1.75} aria-hidden="true" data-id="element-205" data-mp="2w6pkh0tpd2n8" />
                    <span className="text-[15px] font-semibold text-ink" data-id="element-206" data-mp="30za7nji3shhs">+44 (0)20 0000 0000</span>
                  </a>
                  <div className="md:hidden" onClick={() => setOpen(false)} data-id="element-207" data-mp="34zayk3me2l5q">
                    <PillButton href="#contact" data-id="element-208" data-mp="39zyo0kuyytxu">Book a Consultation</PillButton>
                  </div>
                </div>
              </div>
            </motion.div>}
        </AnimatePresence>
      </nav>
    </header>;
}